import React from "react";
import { Image, List, Divider } from "semantic-ui-react";
import { connect } from "react-redux";
import "./ProductsFeatureTemplate.css";

class ProductsFeatureTemplate extends React.Component {
  setFeatureList = features =>
    features.map((feature, index) => (
      <List.Item className="__products_list_item" key={index}>
        {feature.icon && <Image src={feature.icon} alt={this.props.lang.get(feature.title) + ' Icon'} />}
        <List.Content verticalAlign="middle" style={{ paddingLeft: "15px" }}>
          <List.Header as="h3" className="__products_list_item_title">
            {this.props.lang.get(feature.title)}
          </List.Header>
          {feature.message2 ? (
          <div className="__products_list_item_description_wrapper">
            <List.Description className="__products_list_item_description">
                {this.props.lang
                  .get(feature.message) && this.props.lang
                    .get(feature.message)
                    .split("\n")
                    .map((txt, index) => (
                      <p key={index}>{txt}</p>
                    ))}
              </List.Description>
              <div className="__products_list_item_description_divider" />
              <List.Description className="__products_list_item_description">
                {this.props.lang
                  .get(feature.message2) && this.props.lang
                    .get(feature.message2)
                    .split("\n")
                    .map((txt, index) => {
                      const findIntel = txt.match('®');
                      if (findIntel) {
                        const splitWords = txt.split('®');
                        return (
                          <p key={index}>
                            {splitWords[0]}
                            <span className="__products_list_item_description symbol_R">®</span>
                            {splitWords[1]}
                          </p>
                        )
                      }
                      return <p key={index}>{txt}</p>
                    })}
              </List.Description>
          </div>) : (
            <List.Description className="__products_list_item_description">
              {this.props.lang
                .get(feature.message) && this.props.lang
                  .get(feature.message)
                  .split("\n")
                  .map((txt, index) => (
                    <p key={index}>{txt}</p>
                  ))}
            </List.Description>
          )}
        </List.Content>
      </List.Item>
    ));

  render() {
    const { image, title, lang, feature, currentLanguage, children } = this.props;

    let imageSrc = '';
    if (image) {
      imageSrc = require(`../../../../images/products/spec/${image}${currentLanguage === 'en-GB' ? '_in' : ''}.jpg`);
    }

    return (
      <div className="__desktop_products_feature">
        <div className="__desktop_products_feature_left">
          <div className="__desktop_products_left_image_block">
            <Image src={imageSrc} alt={lang.get(title) + " - Digital Signage"} centered />
          </div>
        </div>
        <div className="__desktop_products_feature_right">
          <div className="__desktop_products_right_feature_block">
            <h2 className="__desktop_products_right_feature_block_title">
              {lang.get(title)}
            </h2>
            <div className="__desktop_products_right_feature_block_list">
              <List>{this.setFeatureList(feature)}</List>
            </div>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentLanguage: state.langAction.currentLanguage,
  lang: state.langAction.languageTable
});

export default connect(
  mapStateToProps,
  null
)(ProductsFeatureTemplate);
